import React from 'react';
import { FormGroup } from 'reactstrap';
import { AEAField } from '@components/'
import { ProaSummaryPresenter } from '@presenters/screens/proa-summary.presenter';

export interface IBaseDataProaProps {
    presenter: ProaSummaryPresenter
};

const DetailDataProa = (props: IBaseDataProaProps) => {
    return (
        <div>
            <FormGroup>
                <AEAField {...props.presenter.projectSummaryField} ></AEAField>
                <AEAField {...props.presenter.problemsAndJustificationField}></AEAField>
                <AEAField {...props.presenter.methodologyField}></AEAField>
            </FormGroup>
        </div>
    )
}

export default DetailDataProa;
